import { render } from "./UsersAdministration.vue?vue&type=template&id=63d50d00"
import script from "./UsersAdministration.vue?vue&type=script&lang=js"
export * from "./UsersAdministration.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__